<mat-dialog-content>
  <div [formGroup]="pickupDetailsForm">
    <div class="popup-page book-pickup">
      <div class="row">
        <div class="secondary-details">
          <i class="icon-mat bi bi-building">&nbsp;</i
          ><span>
            {{ 'pickup.bookPickup.bookPickup' | translate }}
          </span>
        </div>

        <div class="col-md-3 form-group m-0 address">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.pickupDate' | translate }}
          </label>
          <label>:</label>
          <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
            <input
              placeholder="
              {{ 'pickup.bookPickup.pleaseSelectDate' | translate }}
              "
              matInput
              class="form-control"
              [matDatepicker]="picker"
              [min]="yesterday"
              [max]="maxDate"
              formControlName="pickupDate"
              (dateChange)="onDate($event)" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <app-error-component
            [controlName]="pickupDetailsForm.get('pickupDate')"></app-error-component>
        </div>

        <div class="col-md-2 form-group m-0">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.noOfPackages' | translate }} </label
          ><label>:</label>
          <input
            matTooltip="{{ 'pickup.bookPickup.minimum1Validation' | translate }}"
            class="form-control"
            type="number"
            min="0"
            formControlName="noOfPackages" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('noOfPackages')"></app-error-component>
        </div>

        <div class="col-md-1 form-group m-0 weight">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.weight' | translate }} {{ 'pickup.bookPickup.KG' | translate }}
          </label>
          <input
            matTooltip=" {{ 'pickup.bookPickup.minimumDecimalValidation' | translate }}"
            class="form-control"
            formControlName="weight"
            type="number"
            min="0" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('weight')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="col-form-label text">
            {{ 'pickup.bookPickup.declaredValue' | translate }}
            :</label
          >
          <input class="form-control" formControlName="declaredValue" type="number" />
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.pickupLocation' | translate }} </label
          ><label>:</label>
          <input formControlName="location" class="form-control" type="text" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('location')"></app-error-component>
        </div>

        <div class="col-md-1 form-group m-0 address" style="width: 12.499999995%">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.readyTime' | translate }}
          </label>
          <label>:</label>
          <input class="form-control" formControlName="readyTime" type="time" />
          <div *ngIf="readyError" class="color: red">
            {{ 'pickup.bookPickup.readyTimeCanNotBePastTime' | translate }}
          </div>
          <app-error-component
            [controlName]="pickupDetailsForm.get('readyTime')"></app-error-component>
        </div>

        <div class="col-md-2 form-group m-0 address" style="width: 12.499999995%">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.closingTime' | translate }}
          </label>
          <label>:</label>
          <input class="form-control" formControlName="closingTime" type="time" />
          <div *ngIf="closeError" class="color: red">
            {{ 'pickup.bookPickup.closingTimeValidationLabel' | translate }}
          </div>
          <app-error-component
            [controlName]="pickupDetailsForm.get('closingTime')"></app-error-component>
        </div>

        <div class="dimensions col-md-3">
          <div class="col-md-4 form-group m-0 pe-0 width">
            <label class="required-field col-form-label text">
              {{ 'pickup.bookPickup.width' | translate }}
            </label>
            <input
              formControlName="width"
              matTooltip="{{ 'pickup.bookPickup.minimum1Validation' | translate }}"
              class="form-control"
              type="number"
              min="0" />
            <app-error-component
              [controlName]="pickupDetailsForm.get('width')"></app-error-component>
          </div>

          <div class="col-md-4 form-group m-0 p-0 length">
            <label class="required-field col-form-label text">
              {{ 'pickup.bookPickup.length' | translate }}
            </label>
            <input
              formControlName="length"
              matTooltip="{{ 'pickup.bookPickup.minimum1Validation' | translate }}"
              class="form-control"
              type="number"
              min="0" />
            <app-error-component
              [controlName]="pickupDetailsForm.get('length')"></app-error-component>
          </div>

          <div class="col-md-4 form-group m-0 ps-0 height">
            <label class="required-field col-form-label text">
              {{ 'pickup.bookPickup.height' | translate }}
            </label>
            <input
              formControlName="height"
              matTooltip="{{ 'pickup.bookPickup.minimum1Validation' | translate }}"
              class="form-control"
              type="number"
              min="0" />
            <app-error-component
              [controlName]="pickupDetailsForm.get('height')"></app-error-component>
          </div>
        </div>

        <div class="col-md-6 form-group m-0">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.pickupInstruction' | translate }} </label
          ><label>:</label>
          <textarea rows="1" class="form-control" formControlName="instructions"></textarea>
          <app-error-component
            [controlName]="pickupDetailsForm.get('instructions')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.companyName' | translate }} </label
          ><label>:</label>
          <input formControlName="shipperCompanyName" class="form-control" type="text" />
          <app-error-component [controlName]="pickupDetailsForm.get('shipperCompanyName')">
          </app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.contactPersonName' | translate }} </label
          ><label>:</label>
          <input formControlName="shipperContactPersonName" class="form-control" type="text" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperContactPersonName')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.addressLine1' | translate }} </label
          ><label>:</label>
          <input formControlName="shipperAddressLine1" class="form-control" type="text" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperAddressLine1')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="col-form-label text">
            {{ 'pickup.bookPickup.addressLine2' | translate }}
            :</label
          >
          <input class="form-control" formControlName="shipperAddressLine2" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperAddressLine2')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="col-form-label text">
            {{ 'pickup.bookPickup.addressLine3' | translate }}
            :</label
          >
          <input class="form-control" formControlName="shipperAddressLine3" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperAddressLine3')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0 address">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.countryName' | translate }}
          </label>
          <label>:</label>
          <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
            <input
              matInput
              type="text"
              formControlName="shipperCountryName"
              [matAutocomplete]="auto" />

            <mat-autocomplete
              (optionSelected)="selectionChanged($event?.option.value)"
              #auto="matAutocomplete">
              <mat-option *ngFor="let item of list" [value]="item?.name">
                {{ item?.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperCountryName')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0 address">
          <label
            class="col-form-label text"
            [ngClass]="{
              'required-field': isPostalCodeReq === true
            }">
            {{ 'pickup.bookPickup.postalCode' | translate }}
          </label>
          <label>:</label>
          <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
            <input
              matInput
              type="text"
              formControlName="shipperPostalCode"
              [matAutocomplete]="autoPostalCode" />
            <mat-autocomplete #autoPostalCode="matAutocomplete">
              <mat-option
                *ngFor="let item of cityList"
                (onSelectionChange)="selectionPincodeChanged($event, item)"
                [value]="item?.postalCode">
                {{ item?.postalCode }} <span *ngIf="item?.city">,</span> {{ item?.city }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperPostalCode')"></app-error-component>
          <span class="msg" *ngIf="!isPostalCodeValid">
            {{ 'pickup.bookPickup.invalidPostalCode' | translate }}
          </span>
        </div>

        <div class="col-md-3 form-group m-0 address">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.cityName' | translate }}
          </label>
          <label>:</label>
          <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
            <input
              matInput
              type="text"
              formControlName="shipperCityName"
              [matAutocomplete]="autoCity" />

            <mat-autocomplete #autoCity="matAutocomplete">
              <mat-option
                *ngFor="let item of cityList"
                (onSelectionChange)="selectionCityChanged($event, item)"
                [value]="item?.city">
                {{ item?.city }}<span *ngIf="item?.postalCode">,</span> {{ item?.postalCode }}
                <span *ngIf="item?.cityDistrict">,</span> {{ item?.cityDistrict }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperCityName')"></app-error-component>
          <span class="msg" *ngIf="!isCityValid || !isAddressValidated">
            {{ 'pickup.bookPickup.invalidCityName' | translate }}
          </span>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.countryCode' | translate }}
          </label>
          <label>:</label>
          <input class="form-control" readonly formControlName="shipperCountryCode" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperCountryCode')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="col-form-label"> {{ 'pickup.bookPickup.suburb' | translate }} </label
          ><label>:</label>
          <input formControlName="shippersuburb" class="form-control" type="text" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('shippersuburb')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="col-form-label text">
            {{ 'pickup.bookPickup.provinceCode' | translate }}
            :
          </label>
          <input formControlName="shipperProvinceCode" class="form-control" type="text" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperProvinceCode')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="required-field col-form-label text">
            {{ 'pickup.bookPickup.phone' | translate }} </label
          ><label>:</label>
          <input formControlName="shipperPhone" class="form-control" type="text" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperPhone')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="col-form-label text">
            {{ 'pickup.bookPickup.email' | translate }}
            :</label
          >
          <input class="form-control" formControlName="shipperEmail" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperEmail')"></app-error-component>
        </div>

        <div class="col-md-3 form-group m-0">
          <label class="col-form-label text">
            {{ 'pickup.bookPickup.mobilePhone' | translate }}
            :</label
          >
          <input formControlName="shipperMobilePhone" class="form-control" type="text" />
          <app-error-component
            [controlName]="pickupDetailsForm.get('shipperMobilePhone')"></app-error-component>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="primary-btn me-2" (click)="closeDialog()">
    {{ 'global.close' | translate }}
  </button>
  <button
    [disabled]="!pickupDetailsForm.valid || !disableBookPickup()"
    class="primary-btn me-2 text-center"
    (click)="bookPickup()">
    {{ 'pickup.bookPickup.bookPickup' | translate }}
  </button>
</mat-dialog-actions>
